module.exports = __webpack_public_path__ + "img/kfzx.fdd30373.png";